import _ from 'underscore';
import {
  FAIL_SEARCH,
  FAIL_SEARCH_MORE,
  REQUEST_SEARCH,
  REQUEST_SEARCH_MORE,
  SUCCESS_SEARCH,
  SUCCESS_SEARCH_MORE,
} from 'shared/searchBarActions';

export default function resultsReducer(state = {}, action) {
  let inProgress;
  let findMoreInProgress;
  let newState;
  let experiment;
  let requestId;
  let results;
  let query;
  let dateRequested;

  switch (action.type) {
  case FAIL_SEARCH:
    inProgress = state.inProgress || 1;

    return {
      ...state,
      ...{
        inProgress: inProgress - 1,
        noMoreResults: true,
      },
    };
  case FAIL_SEARCH_MORE:
    findMoreInProgress = state.findMoreInProgress || 1;
    newState = {
      ...state,
      ...{
        findMoreInProgress: findMoreInProgress - 1,
      },
    };

    if (action.payload.query !== state.query) {
      return newState;
    }

    newState.noMoreResults = true;
    return newState;
  case REQUEST_SEARCH:
    inProgress = state.inProgress || 0;

    return {
      ...state,
      ...{
        inProgress: inProgress + 1,
        noMoreResults: false,
      },
    };
  case REQUEST_SEARCH_MORE:
    findMoreInProgress = state.findMoreInProgress || 0;

    return {
      ...state,
      ...{
        noMoreResults: false,
        findMoreInProgress: findMoreInProgress + 1,
      },
    };
  case SUCCESS_SEARCH:
    inProgress = state.inProgress || 1;
    experiment = action.payload.experiment;
    requestId = action.payload.requestId;
    results = action.payload.results;
    query = action.payload.query;
    dateRequested = action.payload.dateRequested;

    // If for some reason a later search returned first, ignore
    // this one
    if (!!state.lastRequest && dateRequested < state.lastRequest) {
      return state;
    }

    return {
      ...state,
      ...{
        results,
        query,
        experiment,
        requestId,
        lastRequest: dateRequested,
        inProgress: inProgress - 1,
      },
    };
  case SUCCESS_SEARCH_MORE:
    findMoreInProgress = state.findMoreInProgress || 1;
    newState = {
      ...state,
      ...{
        findMoreInProgress: findMoreInProgress - 1,
      },
    };

    experiment = action.payload.experiment;
    requestId = action.payload.requestId;
    results = action.payload.results;
    query = action.payload.query;
    dateRequested = action.payload.dateRequested;

    if (query !== state.query) {
      return newState;
    }

    if (!!state.lastRequest && dateRequested < state.lastRequest) {
      return newState;
    }

    const newResults = _.uniq(state.results.concat(results),
      value => value.feedUserId.type + '-' + value.feedUserId.relatedId);

    newState.experiment = experiment;
    newState.requestId = requestId;
    newState.results = newResults;
    newState.query = query;
    newState.dateRequested = dateRequested;
    newState.noMoreResults = newResults.length >= 200;
    return newState;
  default:
    return state;
  }
}
